// Lib
import React from 'react';

// Components
import Header from '../../../components/Cart/Header';
import Layout from '../../../components/Layout';
import DetailsForm from '../../../components/Cart/ShippingDetails/DetailsForm';
import FooterButtons from '../../../components/Cart/ShippingDetails/FooterButtons';
import IconButton from '../../../components/Button/IconButton/IconButton';
import Feather from '../../../components/Feather';

// Hooks
import useShippingDetails from '../hooks/useShippingDetails';
import useOrderProcessingInfo from '../hooks/useOrderProcessingInfo';

// Styles
import { useStyles } from './ShippingDetailsStyles';

const ShippingDetails = () => {
  const { classes } = useStyles();

  const { onClickBack, onClickNext, isNextButtonDisable, setMonthError } =
    useShippingDetails();
  const { openOrderProcessingWindow } = useOrderProcessingInfo();

  return (
    <Layout className={{ layout: classes.layout }} renderComponent={Header}>
      <IconButton
        data-testid="order-processing-button"
        onClick={openOrderProcessingWindow()}
        className={classes.orderInfoButton}
        endIcon={<Feather nativeColor type="arrowRight" />}>
        See Order Processing Information
      </IconButton>

      <DetailsForm setMonthError={setMonthError} />
      <FooterButtons
        nextButtonDisabled={isNextButtonDisable}
        onClickNext={onClickNext}
        onClickBack={onClickBack}
        backTitle="Shipping Address"
      />
    </Layout>
  );
};

export default ShippingDetails;
